import BackButton from '../BackButton/BackButton'
import './BackHeader.css'

function BackHeader({
  eyebrow,
  title,
  subtitle,
  onBack,
  backLabel = 'Tilbage',
  actions = null,
  theme = 'default',
  className = '',
}) {
  return (
    <header
      className={['back-header', `back-header--${theme}`, className].filter(Boolean).join(' ')}
      onClick={(event) => event.stopPropagation()}
    >
      {onBack ? (
        <BackButton className="back-button--inline" onClick={onBack} label={backLabel} />
      ) : null}
      <div className="back-header__text">
        {eyebrow ? <span className="back-header__eyebrow">{eyebrow}</span> : null}
        <h1 className="back-header__title">{title}</h1>
        {subtitle ? <p className="back-header__subtitle">{subtitle}</p> : null}
      </div>
      {actions ? <div className="back-header__actions">{actions}</div> : null}
    </header>
  )
}

export default BackHeader
